import script from "./TeamSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamSetting.vue?vue&type=script&setup=true&lang=js"

import "./TeamSetting.vue?vue&type=style&index=0&id=3eae490a&lang=scss"

const __exports__ = script;

export default __exports__